import React from 'react';
import { formatValue } from './utils';
import { Tooltip } from '@material-ui/core';
import { Moment } from 'moment';

interface CumulativePerformanceTableProps {
  value: number | null;
  startDate?: Moment | null;
  endDate?: Moment | null;
}

const Figure = ({
  value,
  startDate,
  endDate
}: CumulativePerformanceTableProps) => {
  return (
    <Tooltip
      title={value && startDate && endDate ? `${startDate} → ${endDate}` : ''}
      arrow
    >
      <span style={{ cursor: 'default' }}>{formatValue(value)}</span>
    </Tooltip>
  );
};

export default Figure;
